import createEmotion from '@emotion/css/create-instance';

const config = {
    key: 'ts-tools',
    prepend: true,
};
const { flush, hydrate, cx, merge, getRegisteredStyles, injectGlobal, keyframes, css, sheet, cache, } = createEmotion(config);

export { cache, css, cx, flush, getRegisteredStyles, hydrate, injectGlobal, keyframes, merge, sheet };
//# sourceMappingURL=index.js.map
